import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {LlmRunBatchInfo} from "common/flowmaster/types/llm_run";

export type GetLlmRunBatchesRecentAction = {
  type: WorkflowsActionTypes["LLM_RUN_BATCHES_RECENT_FETCH"]["SUCCESS"];
  payload: LlmRunBatchInfo[];
  action: (organisationId: OrganisationId) => LlmRunBatchInfo[];
};

export default function getLlmRunsRecentBatches(requestor) {
  return createReduxPromiseAction(
    ActionTypes.LLM_RUN_BATCHES_RECENT_FETCH,
    (organisationId: OrganisationId): LlmRunBatchInfo[] => {
      return requestor
        .get(
          `${basePath}/organisation/${organisationId}/llm_run/batch/recent`,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
